import { render, staticRenderFns } from "./BlockCta.vue?vue&type=template&id=097a2bb8"
import script from "./BlockCta.vue?vue&type=script&lang=js"
export * from "./BlockCta.vue?vue&type=script&lang=js"
import style0 from "./BlockCta.vue?vue&type=style&index=0&id=097a2bb8&prod&lang=postcss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports